<!-- <p>incidents-timeline-graph-container works!</p> -->
<mat-card
  [ngClass]="{
    'incident-table-card': screenSize == ScreenType.Desktop,
    'incident-table-card-tablet': screenSize == ScreenType.Tablet,

    'incident-table-card-mobile': screenSize == ScreenType.Mobile
  }"
>
  <mat-card-header
    *ngIf="false"
    [ngClass]="{
      'incident-table-card-header':
        screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,

      'incident-table-card-header-mobile': screenSize == ScreenType.Mobile
    }"
  >
    <div
      [ngClass]="{
        'incident-table-header':
          screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,

        'incident-table-header-mobile': screenSize == ScreenType.Mobile
      }"
    >
      {{ isGraph ? "Status Timeline" : "Timeline Comments" }}
      <button mat-mini-fab (click)="onClose()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </mat-card-header>
  <mat-card-content
    [ngClass]="{
    'incident-table-card-content': isGraph,
    'incident-table-card-content-comments': !isGraph && screenSize != ScreenType.Mobile,
    'incident-table-card-content-comments-mobile': !isGraph && screenSize == ScreenType.Mobile,
  }"
  >
    <app-incident-timeline-serial-graph
      *ngIf="isShowGraphTimeline && incidentStatusTimelineGraph && isGraph"
      [chartData]="incidentStatusTimelineGraph"
      [screenSize]="screenSize"
    >
    </app-incident-timeline-serial-graph>
    <app-incident-timline-graph
      *ngIf="!isShowGraphTimeline && incidentGraph && isGraph"
      [chartData]="incidentGraph"
      [screenSize]="screenSize"
    ></app-incident-timline-graph>
    <app-status-comments
      [selectedCommentId]="selectedCommentId"
      [incident]="incidentDetails"
      [orgUsers]="orgUsersData"
      [screenInfo]="screenSize"
      (onPostComment)="onPostInidentComment($event)"
      *ngIf="!isGraph"
    ></app-status-comments>
  </mat-card-content>
</mat-card>
